// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { PREMIUM_DOMAIN_PRODUCT_VIEW_CLASS_NAME } from "../../../../../core/constants/className";
import { ProductArticle } from "../../../common/productArticle/ProductArticle";
import {
    T_PREMIUM_DOMAIN_WEBSITE,
    T_PREMIUM_DOMAIN_HOSTING,
    T_PREMIUM_DOMAIN_INTRO,
    T_INTRO_ORDER_NOW,
    T_MOVE_NOW,
    T_PREMIUM_DOMAIN_TITLE,
    T_SITE_NAME,
    T_PREMIUM_DOMAINS_ROUTE_TITLE,
    T_PREMIUM_DOMAINS_ROUTE_DESCRIPTION,
} from "../../../../../core/constants/translation";
import {
    PREMIUM_DOMAINS_ROUTE,
} from "../../../../../core/constants/route";
import {
    SENDANOR_PREMIUM_DOMAIN_WEBSITE
} from "../../../../../core/constants/company";
import { PREMIUM_DOMAIN_IMAGE } from "../../../../assets/images";
import { Product } from "../../../../../../../io/hyperify/core/store/types/product/Product";
import { useStoreProductList } from "../../../../../../../io/hyperify/frontend/hooks/useStoreProductList";
import { ProductType } from "../../../../../../../io/hyperify/core/store/types/product/ProductType";
import { LogService } from "../../../../../../../io/hyperify/core/LogService";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";
import "./PremiumDomainProductView.scss";
import { SEODiv } from "../../../common/seo/SEODiv";

const LOG = LogService.createLogger('PremiumDomainProductView');

export interface PremiumDomainProductViewProps {
    readonly t: TranslationFunction;
    readonly className?: string;
}

export function PremiumDomainProductView (props: PremiumDomainProductViewProps) {
    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;
    const description: string[] = [ `${T_PREMIUM_DOMAIN_INTRO}`, `${T_PREMIUM_DOMAIN_WEBSITE}`, `${T_PREMIUM_DOMAIN_HOSTING}` ];
    const productList: Product[] = useStoreProductList(ProductType.PREMIUM_DOMAIN);
    const productModel = productList.length ? productList[0] : undefined;
    const productPrice = productModel && productModel.prices.length >= 1 ? productModel.prices[0] : undefined;
    LOG.debug(`PremiumDomain product: `, productList);
    return (
        <SEODiv className={
            PREMIUM_DOMAIN_PRODUCT_VIEW_CLASS_NAME
            + (className ? ` ${className}` : "")
        }
             path={PREMIUM_DOMAINS_ROUTE}
             title={t(T_PREMIUM_DOMAINS_ROUTE_TITLE)}
             description={t(T_PREMIUM_DOMAINS_ROUTE_DESCRIPTION)}
             siteName={t(T_SITE_NAME)}
        >
            <article className={PREMIUM_DOMAIN_PRODUCT_VIEW_CLASS_NAME+'-article'}>
                <ProductArticle
                    t={t}
                    className={PREMIUM_DOMAIN_PRODUCT_VIEW_CLASS_NAME+'-article-content'}
                    previewImage={PREMIUM_DOMAIN_IMAGE}
                    title={t(T_PREMIUM_DOMAIN_TITLE)}
                    description={description}
                    buyButtonProduct={productModel}
                    buyButtonPrice={productPrice}
                    buyButtonText={t(T_INTRO_ORDER_NOW)}
                    secondaryButtonTo={SENDANOR_PREMIUM_DOMAIN_WEBSITE}
                    secondaryButtonText={t(T_MOVE_NOW)}
                />
            </article>
        </SEODiv>
    );
}
